import React from 'react'
import classNames from 'classnames'
import styled from 'styled-components'

type IconSize = 'sm' | 'md' | 'lg'

interface FontAwesomeIconProps extends React.HTMLAttributes<HTMLElement> {
  iconName: string
  size?: IconSize
}

const FontAwesomeIcon: React.FC<FontAwesomeIconProps> = ({ iconName, size, className, ...props }) => {
  const iconClassName = `fas fa-${iconName} ant-menu-item-icon`

  return <Icon className={classNames(iconClassName, className)} size={size} {...props} />
}

export default FontAwesomeIcon

const Icon = styled.i<{ size?: IconSize }>`
  cursor: pointer;
  font-size: ${(p) => (p.size === 'sm' ? '12px' : p.size === 'lg' ? '24px' : '16px')};
`
